import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { beaconSelector, mortgageSelector } from '../recoil/selector';
import { useEffect, useState } from 'react';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';

export const useMtgCredit = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_CREDIT,
  });

  const sendBeaconClkBtnNext = () => {
    beacon.sendClkBtnNext({
      properties: {
        credit_score: mortgageInfo.credPoint ?? '',
      }
    });
  };

  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const [mortgageInfo] = useRecoilState(Atom.mortgageInfo);
  const [isActive, setActive] = useState<boolean>(false);
  const [warning, setWarning] = useState<string>('');

  const validateCreditPoint = (point: string): boolean => {
    if (!point)
      return true;
    
    const creditPoint = Number(point);
    if (isNaN(creditPoint)) {
      return false;
    } else if (point.indexOf('.') >= 0) {
      return false;
    } else if (creditPoint > 1000) {
      return false;
    } else if (creditPoint === 0) {
      return point.length == 1;
    } else {
      setWarning('');
      return true;
    }
  }

  useEffect(() => {
    if (mortgageInfo.credPoint) {
      const point = Number(mortgageInfo.credPoint);
      if (isNaN(point) || point > 1000 || point < 1) {
        setActive(false);
      } else {
        setActive(true);
      }
    } else {
      setActive(false);
    }
  }, [mortgageInfo]);

  return { isActive, sendBeaconClkBtnNext, warning, validateCreditPoint };
};
